import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { ModusButtonModule } from '@trimble-gcs/modus';
import { filter, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { AuthState } from '../auth.state';
import { logoutTranslations } from './logout.translations';

@UntilDestroy()
@Component({
  imports: [CommonModule, ModusButtonModule, MatProgressSpinnerModule],
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly authService = inject(AuthService);

  readonly translations = logoutTranslations();

  readonly loggedIn = this.store.selectSignal(AuthState.loggedIn);

  ngOnInit() {
    this.store
      .select(AuthState.loggedIn)
      .pipe(
        filter((loggedIn) => loggedIn),
        switchMap(() => {
          return this.authService.signOut();
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }

  login() {
    this.authService.signIn().pipe(untilDestroyed(this)).subscribe();
  }
}
